// src/plugins/vuetify.ts
import Vue from 'vue';
// Change the import path for Vuetify
import Vuetify from 'vuetify'; // Use the standard import path

// Import Vuetify CSS - This remains correct
import 'vuetify/dist/vuetify.min.css';

// Import Material Design Icons - This remains correct
// Ensure @mdi/font is installed (it is listed in your package.json devDependencies)
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

const opts: any = {
  // Add any Vuetify options here
  // Example: Specify the icon font if needed, although often detected automatically
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
};

export default new Vuetify(opts);